import { PERMISSION_TYPE, type PERMISSION_VALUE } from '@/permissions'
import { ROLE_TYPE } from '../permissions'

export enum PAGE_PERMISSION {
  ARROWS = 'ARROWS',
  FRAME = 'FRAME',
  LINK = 'LINK',
  SEO_TAGS = 'SEO_TAGS',
  DUPLICATE = 'DUPLICATE',
  EXPORT_PDF = 'EXPORT_PDF',
  TAG = 'TAG',
}

export const getPagePermissionsMatrix = (): Record<
  PAGE_PERMISSION,
  Record<ROLE_TYPE, PERMISSION_VALUE>
> => {
  return {
    [PAGE_PERMISSION.ARROWS]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [PAGE_PERMISSION.FRAME]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [PAGE_PERMISSION.LINK]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [PAGE_PERMISSION.SEO_TAGS]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [PAGE_PERMISSION.DUPLICATE]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [PAGE_PERMISSION.EXPORT_PDF]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [PAGE_PERMISSION.TAG]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
  }
}
